class DashboardRouter {

  #env

  #envs: {[key: string]: {baseUrl: string}} = {
    'local': {
      baseUrl: 'https://dashboard.devbe.getocra.com',
    },
    'devfe': {
      baseUrl: 'https://dashboard.devbe.getocra.com',
    },
    'stage': {
      baseUrl: 'https://dashboard.stage.getocra.com',
    },
    'main': {
      baseUrl: 'https://dashboard.getocra.com',
    },
  }

  #routes: {[key: string]: string} = {
    'channelFacilityDetail': '/channel-facilities/{channel_facility_id}',
  }

  constructor(env: string) {
    if (!(env in this.#envs)) {
      throw `Invalid env: "${env}"`
    }
    this.#env = env
  }

  get(routeName: string, params?: object, query?: object): string {

    if (!(routeName in this.#routes)) {
      throw `Unknown route: "{routeName}"`
    }

    let url = this.#routes[routeName]

    if (params) {
      Object.entries(params).forEach(([paramName, paramValue]) => {
        const token = `{${paramName}}`
        url = url.replace(token, encodeURIComponent(paramValue))
      })
    }

    if (query) {
      const queryParts: string[] = []
      Object.entries(query).forEach(([varName, varValue]) => {
        queryParts.push(encodeURIComponent(varName) + '=' + encodeURIComponent(varValue))
      })
      if (queryParts.length) {
        url += '?' + queryParts.join('&')
      }
    }

    const baseUrl = this.#envs[this.#env].baseUrl

    return baseUrl + url

  }

}

const ocraEnv = import.meta.env.VITE_OCRA_ENV

export default new DashboardRouter(ocraEnv)
